import { Box, Text } from "@mantine/core";
import { InfoIcon, WarningIcon } from "@phosphor-icons/react";
import type { ReactNode } from "react";
import classes from "./data-grid.module.css";

export type NoticeTone = "warning" | "danger";

type Props = {
  tone?: NoticeTone;
  /** Гарчиг — warning бор (#78350f) / danger улаан (#991b1b), 600. */
  title?: ReactNode;
  /** Тайлбар — gray-7. */
  children?: ReactNode;
  /** Баруун талын үйлдэл (товч). */
  action?: ReactNode;
  icon?: ReactNode;
  role?: "status" | "alert";
};

/**
 * Нийтлэг анхааруулга (canvas): warning = шар, danger = улаан. Гарчиг ба
 * тайлбарын өнгө хоёр тусдаа — тайлбар ямагт саарал.
 */
export function Notice({ tone = "warning", title, children, action, icon, role = "status" }: Props) {
  return (
    <Box className={`${classes.notice} ${tone === "danger" ? classes.noticeDanger : classes.noticeWarning}`} role={role}>
      {icon ?? (tone === "danger" ? <WarningIcon size={18} weight="bold" className={classes.noticeIcon} /> : <InfoIcon size={18} weight="bold" className={classes.noticeIcon} />)}
      <Box className={classes.noticeBody}>
        {title && <Text span className={classes.noticeTitle}>{title}</Text>}
        {children && <Text span className={classes.noticeText}>{children}</Text>}
      </Box>
      {action && <Box className={classes.noticeAction}>{action}</Box>}
    </Box>
  );
}
